import { render, staticRenderFns } from "./IconVideos.vue?vue&type=template&id=0fd26a71"
import script from "./IconVideos.vue?vue&type=script&lang=ts"
export * from "./IconVideos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports